export const environment = {
    ffApiUrl: 'https://app-dgen-dev-noeu-001.azurewebsites.net',
    msal: {
        cliendId: '23ce5fb8-0cf9-47a5-97ce-0d41386a37f8'
    }
};
